import * as React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import CustomListItem from "./CustomListItem";
import UserIcon from "@mui/icons-material/Person";

export const mainListItems = (open, systems) => {
  return (
    <React.Fragment>
      <CustomListItem
        icon={DashboardIcon}
        text="Dashboard"
        to="/dashboard"
        open={open}
      />
      {systems?.map((system) => (
        <CustomListItem
          key={system.id} // Add a unique key for each item
          icon={UserIcon}
          text={system.name}
          to={`/tickets/${system.url}`}
          open={open}
        />
      ))}
      <CustomListItem
        icon={PeopleIcon}
        text="System Mnagement"
        to="system-management"
        open={open}
      />
    </React.Fragment>
  );
};
